import styled from '@emotion/styled';
import { fonts, space } from 'folio-common-components';
import * as React from 'react';
import type { WillHaveEmployees } from '../gqltypes';

export const Pitch: React.FC<{
  willHaveEmployees: WillHaveEmployees;
}> = () => {
  return (
    <>
      <Section>
        <Heading>1. Bank og regnskaps&shy;system som snakker sammen</Heading>
        <p>
          Fiken anbefaler rett og slett Folio! Som Fiken er Folio opptatt av at
          ting skal være enkelt. Folio er også nett&shy;banken Fiken har den
          beste integrasjonen med.
        </p>
      </Section>
      <Section>
        <Heading>2. Raskere regnskap inkludert</Heading>
        <p>
          Inkludert i Folio-kontoen er et kort som lar deg bokføre kjøpene dine
          i farta. Du kan kvitte deg med kvitteringer, og du slipper å betale en
          regnskaps&shy;fører for jobben.
        </p>
      </Section>
      <Section>
        <Heading>3. Garantert av Sparebanken Norge</Heading>
        <p>
          Når du bruker Folio, er det Sparebanken Norge som leverer
          bank&shy;tjenester til deg, og som tar hånd om pengene dine.
          Sparebanken Norge er en av Norges største og eldste sparebanker.
        </p>
      </Section>
      <Section>
        <Heading>4. Prøv gratis</Heading>
        <p>
          Du får Folio helt gratis i en måned, uten noen forpliktelser. Etter
          det koster det 89&nbsp;kr/mnd. Da har du en bedrifts&shy;konto fri for
          skjulte gebyrer, integrert med Fiken! Fiken kan du prøve gratis i 30
          dager. Velger du å forsette etter det, er prisen 199&nbsp;kr/mnd for
          Fiken.
        </p>
      </Section>
    </>
  );
};

export const Heading = styled.h4`
  ${fonts.font300book};
  font-weight: bold;
  margin: 0;
`;

const Section = styled.div`
  ${space([32], 'margin-top')}
`;
